import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  following: [],          // list of followed sellers
  followingCount: 0,
  pagination: null,
  // per-seller follow status cache: { [sellerId]: boolean }
  followStatus: {},
  loading: false,
  actionLoading: false,   // for follow/unfollow button
  error: null,
};

const followSlice = createSlice({
  name: 'follow',
  initialState,
  reducers: {
    setFollowing: (state, action) => {
      state.following = action.payload.following || [];
      state.pagination = action.payload.pagination || null;
      state.loading = false;
      state.error = null;
    },

    setFollowingCount: (state, action) => {
      state.followingCount = action.payload;
    },

    setFollowStatus: (state, action) => {
      const { sellerId, isFollowing } = action.payload;
      state.followStatus[sellerId] = isFollowing;
    },

    // Optimistic toggle
    toggleFollowOptimistic: (state, action) => {
      const { sellerId } = action.payload;
      const current = state.followStatus[sellerId] ?? false;
      state.followStatus[sellerId] = !current;
      state.followingCount += current ? -1 : 1;
    },

    // Revert optimistic update on error
    revertFollowOptimistic: (state, action) => {
      const { sellerId, wasFollowing } = action.payload;
      state.followStatus[sellerId] = wasFollowing;
      state.followingCount += wasFollowing ? 1 : -1;
    },

    setLoading: (state, action) => {
      state.loading = action.payload;
    },

    setActionLoading: (state, action) => {
      state.actionLoading = action.payload;
    },

    setError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },

    clearError: (state) => {
      state.error = null;
    },

    resetFollow: () => initialState,
  },
});

export const {
  setFollowing,
  setFollowingCount,
  setFollowStatus,
  toggleFollowOptimistic,
  revertFollowOptimistic,
  setLoading,
  setActionLoading,
  setError,
  clearError,
  resetFollow,
} = followSlice.actions;

// Selectors
export const selectFollowing = (state) => state.follow.following;
export const selectFollowingCount = (state) => state.follow.followingCount;
export const selectFollowPagination = (state) => state.follow.pagination;
export const selectFollowLoading = (state) => state.follow.loading;
export const selectActionLoading = (state) => state.follow.actionLoading;
export const selectIsFollowing = (sellerId) => (state) =>
  state.follow.followStatus[sellerId] ?? null; // null = unknown (not yet checked)

export default followSlice.reducer;